import { menuItemInterface } from './../../util/interfaces/menuItem';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { faBackward, faWrench } from '@fortawesome/free-solid-svg-icons';
import { genericFormInterface } from 'src/app/util/interfaces/genericForm';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';

@Component({
	selector: 'pcp-custom-columns-excel',
	templateUrl: './custom-columns-excel.component.html',
	styleUrls: ['./custom-columns-excel.component.scss'],
})
export class CustomColumnsExcelComponent implements OnInit {
	icons = {
		faWrench: faWrench,
		faBackward: faBackward,
	};

	labels: LabelsInterface = {
		lbl_salvo_com_sucesso: 'Saved successfully',
		lbl_salvar_colunas: 'Save Columns',
		lbl_redefinir_colunas: 'Reset Columns',
		lbl_selecione_as_colunas_que_deseja_ocultar: 'Select the columns you want to hide',
	};

	@Output()
	spreadsheetInView = new EventEmitter();

	constructor(
		private LabelsService: LabelsService,
		private NotificationService: NotificationService
	) {}

	isLoadingLabels = true;
	isSavingConfiguration = false;

	@Input()
	pageView = 'spreadsheet';

	@Input()
	spreadsheet: any[][] = [];
	memorySpreadsheet: any[][] = [];

	configurationSpreadsheet: genericFormInterface[] = [
		{
			name: 'hideColumns',
			label: 'lbl_selecione_as_colunas_que_deseja_ocultar',
			inputType: 'multi-select',
			values: [],
			outItems: [],
			items: [],
			filterItem: [''],
			filterValues: [''],
			rawValues: [''],
		},
	];
	memoryConfigurationSpreadsheet: genericFormInterface[] = [];

	ngOnInit() {
		this.LabelsService.getLabels().subscribe((labels) => {
			this.labels = labels;
			this.isLoadingLabels = false;
		});

		this.generateBlankCells();
		this.generateConfigurationForm();

		this.memorySpreadsheet = structuredClone(this.spreadsheet);
		this.memoryConfigurationSpreadsheet = structuredClone(this.configurationSpreadsheet);
	}

	goToConfigurationView(): void {
		this.pageView = 'configuration';
		this.memoryConfigurationSpreadsheet = structuredClone(this.configurationSpreadsheet);
	}

	goToSpreadsheetView(): void {
		this.pageView = 'spreadsheet';
		this.configurationSpreadsheet = structuredClone(this.memoryConfigurationSpreadsheet);
	}

	generateBlankCells(): void {
		let lessThan10Columns = false;
		let lessThan10Lines = false;
		if (this.spreadsheet.length < 10) lessThan10Lines = true;
		if (this.spreadsheet[0].length < 10) lessThan10Columns = true;
		//Número mínimo de colunas e linhas é 10, então definimos celulas vazias para preencher o espaço

		if (lessThan10Columns) {
			for (const line of this.spreadsheet) {
				while (line.length < 10) line.push('');
			}
		}

		if (lessThan10Lines) {
			const columns = this.spreadsheet[0].length;
			for (let index = this.spreadsheet.length; index <= 10; index++) {
				const line = [];
				for (let index = 0; index < columns; index++) {
					line.push('');
				}
				this.spreadsheet.push(line);
			}
		}
	}

	generateConfigurationForm() {
		for (const cell of this.spreadsheet[0]) {
			this.configurationSpreadsheet[0].items.push(cell);
		}

		let arrayItens = [];
		arrayItens = this.configurationSpreadsheet[0].items;
		this.configurationSpreadsheet[0].items = [];
		this.configurationSpreadsheet[0].rawValues = [];

		for (const availableItems of arrayItens) {
			const newItem: genericFormInterface['items'][number] = {
				name: availableItems.toString(),
				label: availableItems,
				value: availableItems,
				values: [availableItems],
			};
			this.configurationSpreadsheet[0].items.push(newItem);
		}
	}

	saveConfiguration() {
		if (this.isSavingConfiguration) return;

		this.isSavingConfiguration = true;

		this.spreadsheet = structuredClone(this.memorySpreadsheet);
		this.memoryConfigurationSpreadsheet = structuredClone(this.configurationSpreadsheet);

		for (const value of this.configurationSpreadsheet[0].rawValues) {
			const index = this.spreadsheet[0].indexOf(value, 0);
			this.deleteColumn(index);
		}

		this.generateBlankCells();

		this.NotificationService.setNotificationMessage(this.labels.lbl_salvo_com_sucesso);
		this.spreadsheetInView.emit(this.spreadsheet);
		this.isSavingConfiguration = false;
	}

	deleteColumn(n: number): void {
		for (let index = 0; index < this.spreadsheet.length; index++) {
			this.spreadsheet[index].splice(n, 1);
		}
	}
}
